export function findPos (obj: HTMLDivElement) {
  let curtop = 0
  if (obj.offsetParent) {
    do {
      curtop += obj.offsetTop
    } while (obj === obj.offsetParent)
    return [curtop]
  }
}
